module.exports = __webpack_public_path__ + "img/Stemness-LICA_GSE236681.1fdf99f1.png";